const possibleBooleanValues = ['false', 'true', '0', '1'];

export default function isValidBoolean(value) {
  return possibleBooleanValues.includes(value.toString().toLowerCase());
}
